import network from "./network";
import { getWatchlistCache, setWatchlistCache } from "../utils/watchlist-cache";
import axios from "axios";
import { aiQaSaveUrl, aiQuestionDeleteUrl, aiQuestionListUrl, aiQuestionUrl, aiTrendingUrl, getWatchListUrl, updateWatchListUrl, pairListUrl } from "./const";
import { AI_QUESTIONS_LIST, AI_TRENDING_LIST, GET_NEWS_PAIRS, GET_USER_WATCHLIST } from "./types";

export const submitQuery = (question) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .post(aiQuestionUrl, {question:question},dispatch,
            getState)
        .then((res) => {
            const { code} = res.data;
            if (code == 200) {
                resolve(res.data.bard_qa)
            } else {
                reject()
            }
        })
        .catch((err) => {
            reject(err)
        });
    });
};
export const saveQuestion = (question,answer) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .post(aiQaSaveUrl, {question:question,answer:answer},dispatch,
            getState)
        .then((res) => {
            const { code} = res.data;
            if (code == 200) {
                resolve(res.data)
            } else {
                reject()
            }
        })
        .catch((err) => {
            reject(err)
        });
    });
};
export const fetchQuestions = (exchangeId,pageSize,page) => (dispatch, getState) => {
        network
        .get(aiQuestionListUrl, {"page_size":pageSize,page},dispatch,
            getState)
        .then((res) => {
            const { code,bard_qas} = res.data
            if (code == 200) {
                dispatch({
                    type:AI_QUESTIONS_LIST,
                    payload:{
                        questions:bard_qas.data,
                        startItem:pageSize?bard_qas.from:1,
                        total:bard_qas.total
                    }
                })
            } 
        })
        .catch((err) => {
            //reject(err)
        });
};
export const getTrending = () => (dispatch, getState) => {
    const cachedTrending = localStorage.getItem("ai_trending_cache");
    if (cachedTrending) {
        dispatch({
            type: AI_TRENDING_LIST,
            payload: JSON.parse(cachedTrending)
        });
        return; // Return early if cache exists
    }

    network
        .get(aiTrendingUrl, {}, dispatch, getState)
        .then((res) => {
            const { code, trending } = res.data
            if (code == 200) {
                localStorage.setItem("ai_trending_cache", JSON.stringify(trending));
                dispatch({
                    type: AI_TRENDING_LIST,
                    payload: trending
                })
            }
        })
        .catch((err) => {
            //reject(err)
        });
};

export const deleteQuery = (id) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .delete(aiQuestionDeleteUrl+id, {},dispatch,
            getState)
        .then((res) => {
            const { code} = res.data;
            if (code == 200) {
                resolve(res.data)
            } else {
                reject()
            }
        })
        .catch((err) => {
            reject(err)
        });
    });
};

export const getWatchlist = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const cachedWatchlist = getWatchlistCache();
        if (cachedWatchlist) {
            const { watch_list, news_pairs } = cachedWatchlist;
            
             // Dispatch full list for Search/Dropdowns
             if (news_pairs) {
                dispatch({
                    type: GET_NEWS_PAIRS,
                    payload: news_pairs
                });
            }
            // Dispatch user's list for management
            if (watch_list) {
                dispatch({
                    type: GET_USER_WATCHLIST,
                    payload: watch_list
                });
            }
            resolve({ watch_list, news_pairs });
            return;
        }

        network
        .get(getWatchListUrl, {}, dispatch, getState)
        .then((res) => {
            const { code, watch_list, news_pairs } = res.data;
            
            if (code == 200) {
                setWatchlistCache({ watch_list, news_pairs });
                // Dispatch full list for Search/Dropdowns
                if (news_pairs) {
                    dispatch({
                        type: GET_NEWS_PAIRS,
                        payload: news_pairs
                    });
                }
                // Dispatch user's list for management
                if (watch_list) {
                    dispatch({
                        type: GET_USER_WATCHLIST,
                        payload: watch_list
                    });
                }
                resolve({ watch_list, news_pairs });
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const updateWatchlist = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .post(updateWatchListUrl, { pair_id: pairId, status: 1 }, dispatch, getState)
        .then((res) => {
            const { code } = res.data;
            if (code == 200) {
                localStorage.removeItem("ai_watchlist_cache");
                dispatch(getWatchlist()); // Refresh list
                resolve(res.data);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const removeFromWatchlist = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .delete(updateWatchListUrl, { pair_id: pairId }, dispatch, getState) 
        .then((res) => {
            const { code } = res.data;
            if (code == 200) {
                localStorage.removeItem("ai_watchlist_cache");
                dispatch(getWatchlist());
                resolve(res.data);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

